import Vue from 'vue'
import firebase from 'firebase';
require("firebase/firestore");

var config = {
  apiKey: "AIzaSyDntaWCizu3JEhOFGjusj6AUZrumcq94OY",
  authDomain: "vue-data-table-01.firebaseapp.com",
  databaseURL: "https://vue-data-table-01.firebaseio.com",
  projectId: "vue-data-table-01",
  storageBucket: "vue-data-table-01.appspot.com",
  messagingSenderId: "438700408690"
};

import App from './App.vue'

firebase.initializeApp(config);

var db = firebase.firestore();

db.settings({
  timestampsInSnapshots: true
});

// make the db variable accessible throuhout the app
window.db = db;

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app')
